exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blueText[data-v-1d528a4e] {\n  color: #12bcf1;\n}\n.floating-block-popup[data-v-1d528a4e] {\n    width: 50%;\n    margin-left: 25%;\n}\n.floating-button-popup[data-v-1d528a4e] {\n  right: 15px;\n  bottom: 15px;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  z-index: 1500;\n  background-color: #12bcf1;\n  color: #fff;\n  overflow: hidden;\n  -webkit-transition-duration: .3s;\n  transition-duration: .3s;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.attachementCreateInvoiceButtonLength[data-v-1d528a4e] {\n  width: 100%;\n}\nul[data-v-1d528a4e] {\n  padding-left: 0%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d528a4e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/attachments/CMAttachmentsCreateRefund.vue
// module id = 1516
// module chunks = 2